import {useSelector} from "react-redux"
import {useStoreDetails} from "./useStoreDetails"

export default function useShippingLabel(isBillingAddress) {
  const { storeDetails } = useSelector(({ store }) => store);

  const shippingLabelLower = storeDetails?.delivery_method_lable?.toLowerCase() || "delivery"
  const shippingLabelTitle = shippingLabelLower.charAt(0).toUpperCase() + shippingLabelLower.slice(1)

  useStoreDetails(!isBillingAddress)

  if (isBillingAddress) {
    return {
      shippingLabelLower: "billing",
      shippingLabelTitle: "Billing"
    }
  }

  return {
    shippingLabelLower,
    shippingLabelTitle,
  }
}
